import {h, render} from 'preact';
import Provider from 'preact-context-provider';
import {client} from '@core/GraphQLProvider';
import UEStatusContainer from '@containers/UEStatus';

export default {
    init () {
        const ueProgress = document.getElementById( 'ue-status-progress' );
        const ueProgressNav = document.getElementById( 'nav-menu--ue-status-progress' );

        if ( ueProgress ) {
            render(
                <Provider client={client}>
                    <UEStatusContainer className="w-full md:flex justify-between text-xl" showFullDetail={true}/>
                </Provider>,
                ueProgress
            );
        }

        if ( ueProgressNav ) {
            // only access api if nav menu interacted with
            const navObserver = new IntersectionObserver( entries => {
                entries.map( entry => {
                    if ( entry.intersectionRatio > 0 ) {
                        render(
                            <Provider client={client}>
                                <UEStatusContainer className="flex w-full text-center justify-around fade-in"
                                                   size={112}/>
                            </Provider>,
                            null,
                            ueProgressNav
                        );
                        navObserver.unobserve( ueProgressNav );
                    }
                } )
            } );

            navObserver.observe( ueProgressNav )
        }
    }
}
